import LayoutLanding from "@/layouts/LayoutLanding/LayoutLanding.vue";
import { sentencesIndexItems } from "@/common/navigation";
import { isSmallDevice, getCurrentSubdomain } from "@/common/functions";
import Advertising from "@/components/Advertising/Advertising.vue";
import OneTrustService from "@/services/OneTrustService";

export default {
    components: {
        LayoutLanding,
        SearchBox: () =>
            import(
                /* webpackChunkName: "searchBox" */ "@/components/Search/SearchBox/SearchBox.vue"
            ),
        BrowsePanel: () =>
            import(
                /* webpackChunkName: "browsePanel" */ "@/components/BrowseByIndexPanel/BrowsePanel/BrowsePanel.vue"
            ),
        Advertising
    },
    data() {
        return {
            layout: LayoutLanding,
            sentencesIndexItems,
            subdomain: getCurrentSubdomain()
        };
    },
    methods: {
        isSmallDevice
    },
    metaInfo() {
        return {
            title: this.$t(`sentenceLandingPageMetaTitle`),
            meta: [
                {
                    name: "description",
                    content: this.$t(`sentenceLandingPageMetaDescription`)
                },
                {
                    name: "keywords",
                    content: this.$t(`sentenceLandingPageMetaKeywords`)
                }
            ],
            link: [
                {
                    rel: "canonical",
                    href: `https://sentence.yourdictionary.com/`
                }
            ]
        };
    },
    created() {
        this.$emit("update:layout", LayoutLanding);
    },
    mounted() {
        if (typeof window.__PRERENDER_INJECTED !== "undefined") {
            setTimeout(() => {
                window.document.dispatchEvent(new CustomEvent("spa-render-complete"));
            }, 200);
        } else {
            // Run only on client side
            OneTrustService.setListeners(this);
            permutive.addon("web", {
                page: {
                    data: {
                        slug: this.$route.path,
                        title: this.$metaInfo.title,
                        type: "search_results",
                        section: "Sentence (V2)",
                        subsection: "Home"
                    }
                }
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/pages/Sentences/Home/SentencesHome.js